import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "my-6" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold mb-6" }, "Historical Documents")
], -1)

import { inject, ref } from "vue";
import { useI18n } from "vue-i18n";
import { VerificationDocumentTypes } from "@/core/types/VerificationInfos";
import UserImageDoc from "@/projects/tenant/modules/users/components/UserImageDoc.vue";
import { userDocumentsInjectionKeys } from "./UserDocumentsInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoricalDocuments',
  setup(__props) {

const { t } = useI18n();

const historicalDocuments = inject(
  userDocumentsInjectionKeys.historicalDocuments,
  ref<Array<any>>([])
);
const verificationDetails = inject(
  userDocumentsInjectionKeys.verificationDetails,
  ref<any>(null)
);
const isShowUserInfos = inject(
  userDocumentsInjectionKeys.isShowUserInfos,
  ref(false)
);
const refreshData = inject(
  userDocumentsInjectionKeys.refreshData,
  async () => undefined
);

const documentTitleKeys: Record<string, string> = {
  [VerificationDocumentTypes.IdFront]: "tip.idFront",
  [VerificationDocumentTypes.IdBack]: "tip.idBack",
  [VerificationDocumentTypes.Address]: "tip.addressDocument",
  [VerificationDocumentTypes.Selfie]: "title.selfie",
};

const documentTitle = (item: any) => {
  const documentType = item?.documentType ?? item?.type;
  const key = documentTitleKeys[documentType];
  return key ? t(key) : item?.fileName;
};

return (_ctx: any,_cache: any) => {
  return (_unref(historicalDocuments).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", {
          class: _normalizeClass(["flex-wrap", {
        'd-flex': !_unref(isShowUserInfos),
      }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(historicalDocuments), (item, index) => {
            return (_openBlock(), _createBlock(UserImageDoc, {
              key: item.id ?? item.guid ?? index,
              class: "me-3 mb-5",
              title: item.context || documentTitle(item),
              media: item,
              "verification-details": _unref(verificationDetails),
              "disabled-action": true,
              "enable-delete": "",
              onFileDeleted: _unref(refreshData)
            }, null, 8, ["title", "media", "verification-details", "onFileDeleted"]))
          }), 128))
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})